import { render, staticRenderFns } from "./SupplierDocuments.vue?vue&type=template&id=051a6388&"
import script from "./SupplierDocuments.vue?vue&type=script&lang=js&"
export * from "./SupplierDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports